module.exports = __webpack_public_path__ + "media/images/iron-bg-33dbaa75736b6ca812538bf2d3c52976.jpg";